module.exports = __webpack_public_path__ + "img/flux.fecc398a.svg";